import { render } from "./Homeicon.vue?vue&type=template&id=a3681896&scoped=true"
import script from "./Homeicon.vue?vue&type=script&lang=js"
export * from "./Homeicon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3681896"]])

export default __exports__